
export default function ComplianceSection() {
  const certifications = [
    {
      name: 'QCDD',
      description: 'Qatar Civil Defence Directorate Approved',
      icon: 'ri-shield-check-line',
      color: 'text-red-600 bg-red-100'
    },
    {
      name: 'CE Marking',
      description: 'European Conformity Certified',
      icon: 'ri-verified-badge-line',
      color: 'text-blue-600 bg-blue-100'
    },
    {
      name: 'ISO 9001',
      description: 'Quality Management System',
      icon: 'ri-medal-line',
      color: 'text-green-600 bg-green-100'
    },
    {
      name: 'RoHS',
      description: 'Restriction of Hazardous Substances',
      icon: 'ri-leaf-line',
      color: 'text-emerald-600 bg-emerald-100'
    }
  ];

  return (
    <section className="bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Certifications & Compliance</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our emergency exit signs meet the highest international standards and local regulations for emergency lighting systems
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {certifications.map((cert, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition-shadow text-center">
              <div className={`w-16 h-16 ${cert.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                <i className={`${cert.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{cert.name}</h3>
              <p className="text-sm text-gray-600">{cert.description}</p>
            </div>
          ))}
        </div>

        {/* Compliance Details */}
        <div className="bg-white rounded-2xl p-8 shadow-sm">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Standards Compliance</h3>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>IEC 60598-2-22: Emergency lighting luminaires</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>EN 60598-2-22: Emergency lighting requirements</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>ISO 3864: Graphical symbols for safety signs</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>QCDD Fire Safety Regulations for Qatar</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Quality Assurance</h3>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>Automatic self-testing functionality</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>Battery performance monitoring</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>LED performance verification</span>
                </li>
                <li className="flex items-start space-x-3">
                  <i className="ri-check-line text-green-600 mt-1"></i>
                  <span>Professional installation support</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
